export class SituacaoEleitoral{
  id: number = null;
  data: Date = null;
  status: string = null;
  situacao: string = null;
  primeiroTurno: string = null;
  segundoTurno: string = null;
  cumprimento: boolean = null;

  constructor(d?){
    if (d) {
      this.id = d.id ? d.id : null;
      this.data = d.data ? d.data : null;
      this.status = d.status ? d.status : null;
      this.situacao = d.situacao ? d.situacao : null;
      this.primeiroTurno = d.primeiroTurno ? d.primeiroTurno : null;
      this.segundoTurno = d.isegundoTurnod ? d.segundoTurno : null;
      this.cumprimento = d.cumprimento ? d.cumprimento : null;
    }
  }

}
